<template>
  <p class="summary_calendar">
    <a
      class="summary_calendar_item"
      v-for="(date, index) in dates"
      :key="index"
      :class="{ 'actual': date.active }"
      @click.prevent="onDayClick(date)"
    >
      {{ formatDateCalendar(date.title) }} <span>{{ date.text }}</span>
    </a>
  </p>
</template>

<script>
import moment from 'moment'
import formatDateMixin from '../../mixins/formatDateMixin'

export default {
  name: 'days',
  mixins: [formatDateMixin],
  props: {
    dateFrom: {
      type: Number,
      required: true
    },
    dateTo: {
      type: Number,
      required: true
    }
  },
  data() {
    const todayDate = moment()
    const fromDate = moment.unix(this.dateFrom)
    const toDate = moment.unix(this.dateTo)
    const dates = []

    if (fromDate.isAfter(toDate)) {
      return { dates }
    }

    while (!fromDate.isSame(toDate, 'day')) {
      const today = fromDate.isSame(todayDate, 'day')

      dates.push({
        active: today,
        title: today ? this.$gettext('Dnes') : fromDate.format('ddd'),
        text: fromDate.format('D. M.'),
        date: fromDate.clone()
      })
      fromDate.add(1, 'days')
    }

    return {
      dates
    }
  },
  methods: {
    onDayClick(date) {
      // add 1ms to make the ISO string different,
      // so when we click the same day twice, the overview gets closed because query has changed
      this.$router.push({
        name: 'program',
        query: {
          fromDay: date.date.add(1, 'ms').toISOString()
        }
      })
    }
  }
}
</script>
